'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _angularFix = require('angular-fix');

var _angularFix2 = _interopRequireDefault(_angularFix);

exports['default'] = formlyCustomValidation;

// @ngInject
function formlyCustomValidation(formlyUtil) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function formlyCustomValidationLink(scope, el, attrs, ctrl) {
      var opts = scope.options;
      opts.validation.messages = opts.validation.messages || {};
      _angularFix2['default'].forEach(opts.validation.messages, function (message, key) {
        opts.validation.messages[key] = function () {
          return formlyUtil.formlyEval(scope, message, ctrl.$modelValue, ctrl.$viewValue);
        };
      });

      var useNewValidatorsApi = ctrl.hasOwnProperty('$validators') && !attrs.hasOwnProperty('useParsers');
      _angularFix2['default'].forEach(opts.validators, _angularFix2['default'].bind(null, addValidatorToPipeline, false));
      _angularFix2['default'].forEach(opts.asyncValidators, _angularFix2['default'].bind(null, addValidatorToPipeline, true));

      function addValidatorToPipeline(isAsync, validator, name) {
        setupMessage(validator, name);
        validator = _angularFix2['default'].isObject(validator) ? validator.expression : validator;
        if (useNewValidatorsApi) {
          setupWithValidators(validator, name, isAsync);
        } else {
          setupWithParsers(validator, name, isAsync);
        }
      }

      function setupMessage(validator, name) {
        var message = validator.message;
        if (message) {
          opts.validation.messages[name] = function () {
            return formlyUtil.formlyEval(scope, message, ctrl.$modelValue, ctrl.$viewValue);
          };
        }
      }

      function setupWithValidators(validator, name, isAsync) {
        var validatorCollection = isAsync ? '$asyncValidators' : '$validators';

        ctrl[validatorCollection][name] = function evalValidity(modelValue, viewValue) {
          return formlyUtil.formlyEval(scope, validator, modelValue, viewValue);
        };
      }

      function setupWithParsers(validator, name, isAsync) {
        var inFlightValidator = undefined;
        ctrl.$parsers.unshift(function evalValidityOfParser(viewValue) {
          var isValid = formlyUtil.formlyEval(scope, validator, ctrl.$modelValue, viewValue);
          if (isAsync) {
            ctrl.$pending = ctrl.$pending || {};
            ctrl.$pending[name] = true;
            inFlightValidator = isValid;
            isValid.then(function () {
              if (inFlightValidator === isValid) {
                ctrl.$setValidity(name, true);
              }
            })['catch'](function () {
              if (inFlightValidator === isValid) {
                ctrl.$setValidity(name, false);
              }
            })['finally'](function () {
              var $pending = ctrl.$pending || {};
              if (Object.keys($pending).length === 1) {
                delete ctrl.$pending;
              } else {
                delete ctrl.$pending[name];
              }
            });
          } else {
            ctrl.$setValidity(name, isValid);
          }
          return viewValue;
        });
      }
    }
  };
}
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./directives/formly-custom-validation.js
 **/